export const isObjectEmpty = (obj: any) => {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
};

export const removeNullProperties = <T extends object>(inputObject: T): Partial<T> => {
  return Object.keys(inputObject).reduce((filteredObject, key) => {
    const value = inputObject[key as keyof T];
    if (value !== null && typeof value !== "undefined" && value !== "") {
      filteredObject[key as keyof T] = value;
    }
    return filteredObject;
  }, {} as Partial<T>);
};
